
import { useState } from "react"
import { Link } from "react-router-dom"
// import CartExpirationTimer from "../components/elements/CartExpirationTimer"
import CartExpirationTimer from "../../elements/CartExpirationTimer"
import Menu from "../Menu"

export default function Header1({ scroll, isMobileMenu, handleMobileMenu, isCart, handleCart, isLogin, handleLogin, isRegister, handleRegister, isForgotPass, handleForgotPass }) {
	const [isToggled, setToggled] = useState(false)
	const handleToggled = () => setToggled(!isToggled)
	return (
		<>

			<div className="header-top">
				<div className="themeflat-container">
					<div className="header-top-inner">
						<div className="address">
							<Link to="/mailto:"><i className="icon-Vector" />hazakazaka@fandriana-milay.org</Link>
							<address><i className="icon-Vector-22" />034 41 099 09 / 032 02 006 16 </address>
						</div>
						<div className="social-icon">
							<Link to="/facebook.com"><i className="icon-facebook" /></Link>
							<Link to="/youtube.com"><i className="icon-youtube" /></Link>
						</div>
					</div>
				</div>
			</div>

			<header id="header" className={`header style1 clearfix ${scroll ? 'downscrolled' : ''}`}>
				<div className="themeflat-container">
					<div className="header-inner">
						<div id="logo" className="logo">
							<Link to="/" rel="home">
								<img id="a2" src="images/logo-fm.png" alt="image" />
							</Link>
						</div>{/* /.logo */}
						<div className="nav-wrap">
							<div className="btn-menu" onClick={handleMobileMenu}>
								<span className="line-1" />
							</div>{/* //mobile menu button */}
							<nav id="mainnav" className="mainnav">
								<div id="logo-mobie" className="logo">
									<Link to="/" rel="home">
										<img src="images/logo-fm.png" alt="image" />
									</Link>
								</div>{/* /.logo */}
								<Menu />
							</nav>{/* /.mainnav */}
						</div>{/* /.nav-wrap */}
						<div className="header-right">
							<div className="search">
								<a className={`show-search ${isToggled ? 'active-search' : ''}`} onClick={handleToggled}>
									<svg width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
										<path d="M21.0004 21.0004L16.6504 16.6504" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
									</svg>
								</a>
								<div className={`widget widget-search top-search ${isToggled ? 'active' : ''}`}>
									<form id="searchform" method="get">
										<div>
											<input type="text" id="s" className="sss" placeholder="Search" />
											<button aria-label="Search" className="wp-element-button" type="submit"><i className="icon-U" /></button>
										</div>
									</form>
								</div>{/* /.widget-search */}
							</div>

							<button className="btn-contact">📞034 41 099 09 | 📞 032 02 006 16</button>
							{/* /.login/register */}
						</div>{/* /.login-wrap */}
					</div>{/* /.header-inner */}
				</div>
			</header>

		</>
	)
}
